module.exports = __webpack_public_path__ + "/login_ui/img/nato-ee323b9ab6fa042bab246fc50fbf1721.svg";